import { render, staticRenderFns } from "./inputForm.vue?vue&type=template&id=5dc247fd&scoped=true"
import script from "./inputForm.vue?vue&type=script&lang=js"
export * from "./inputForm.vue?vue&type=script&lang=js"
import style0 from "./inputForm.vue?vue&type=style&index=0&id=5dc247fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc247fd",
  null
  
)

export default component.exports